import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

// 导入的按需引入组件
import {
  ConfigProvider,
  NavBar,
  Button,
  Icon,
  Image,
  IndexBar, 
  IndexAnchor,
  Picker,
  DatetimePicker,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Form,
  Field,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Popup,
  Uploader,
  PullRefresh,
  List,
  Search,
  ImagePreview,
  Empty,
  Overlay
} from "vant"

const app = createApp(App)

// 挂载组件
app.component("van-config-provider", ConfigProvider)
app.component("van-nav-bar", NavBar)
app.component("van-icon", Icon)
app.component("van-image", Image)
app.component("van-button", Button)
app.component("van-popup", Popup)
app.component("van-uploader", Uploader)

app.component("van-picker", Picker)
app.component("van-datetime-picker", DatetimePicker)
app.component("van-radio-group", RadioGroup)
app.component("van-radio", Radio)
app.component("van-checkbox", Checkbox)
app.component("van-checkbox-group", CheckboxGroup)
app.component("van-form", Form)
app.component("van-field", Field)
app.component("van-cell", Cell)
app.component("van-cell-group", CellGroup)
app.component("van-dropdown-menu", DropdownMenu)
app.component("van-dropdown-item", DropdownItem)
app.component("van-pull-refresh", PullRefresh)
app.component("van-list", List)
app.component("van-search", Search)
app.component("van-image-preview", ImagePreview)
app.component("van-empty", Empty)

app.component("van-overlay", Overlay)

app.component("van-index-bar", IndexBar)
app.component("van-index-anchor", IndexAnchor)

app.use(store).use(router).mount("#app")

